import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { Container, RegularText, Row } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { fontSizes, metrics } from 'src/themes/Metrics';
import { DropdownType } from 'src/types/types';
import styled from 'styled-components/native';

interface Props {
  label: string;
  data: DropdownType[];
  row?: boolean;
  value?: any;
  onChange(val: any): void;
  disabled?: boolean;
  isRequire?: boolean;
  error?: string;
}

const Styled = {
  Wrapper: styled.View`
    height: ${metrics.inputHeight}px;
    border-radius: ${metrics.borderRadius}px;
    width: 100%;
    padding-horizontal: ${metrics.medium}px;
  `,
  // border-width: ${StyleSheet.hairlineWidth}px;
  // border-color: ${AppColors.border};
};

export const CustomDropDown = ({ error, label, data, row, value, onChange, disabled, isRequire }: Props) => {
  return (
    <Container style={row ? { flex: 1 } : { width: '100%' }}>
      <Styled.Wrapper>
        <Row paddingTop={metrics.small}>
          <RegularText color={AppColors.gray} fontSize="small" textLang={label} />
          {isRequire && (
            <RegularText color={AppColors.red} fontSize="medium">
              *
            </RegularText>
          )}
        </Row>
        <Select
          defaultValue=""
          disabled={disabled}
          disableUnderline
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value || ''}
          variant="standard"
          onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
          sx={{
            height: 36,
            fontSize: fontSizes.medium,
          }}>
          {data.map((d, index) => (
            <MenuItem defaultValue="" key={index.toString()} sx={{ fontSize: fontSizes.medium }} value={d.value}>
              {d.label}
            </MenuItem>
          ))}
        </Select>
      </Styled.Wrapper>
      {error && (
        <RegularText
          style={{ marginLeft: metrics.tiny, marginTop: metrics.small }}
          textAlign="left"
          color={AppColors.red}
          numberOfLines={1}
          fontSize="small">
          {error}
        </RegularText>
      )}
    </Container>
  );

  // return (
  //   <Styled.Wrapper style={row ? { flex: 1 } : { width: '100%' }}>
  //     <Row style={{ position: 'absolute', top: 0, left: 0, zIndex: 9999 }} padding={metrics.medium}>
  //       <RegularText color={AppColors.gray} fontSize="small" textLang={label} />
  //       {isRequire && (
  //         <RegularText color={AppColors.red} fontSize="medium">
  //           *
  //         </RegularText>
  //       )}
  //     </Row>
  //     <SizedBox height={pixelScaler(13)} />
  //     <DropDownPicker
  //       disabled={disabled}
  //       style={{ borderWidth: 0, minHeight: pixelScaler(35) }}
  //       dropDownContainerStyle={{ borderColor: AppColors.border }}
  //       open={open}
  //       value={value}
  //       items={items}
  //       setOpen={setOpen}
  //       setValue={val => onChange(val(value))}
  //       setItems={setItems}
  //       placeholder="Select"
  //       placeholderStyle={{ color: AppColors.gray, fontSize: fontSizes.medium }}
  //     />
  //   </Styled.Wrapper>
  // );
};
